"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const common_styled_components_1 = require("../../common-styled-components");
const compliance_pool_types_1 = require("../compliance-pool-types");
const useFetch_1 = __importDefault(require("../../../hooks/useFetch"));
const useEdit_1 = __importDefault(require("../../../hooks/useEdit"));
const Modal_1 = require("../common/Modal");
const apiUtils_1 = require("../../../util/apiUtils");
const isNullish_1 = require("../../../util/isNullish");
const YearContext_1 = require("../../../contexts/YearContext");
const tableColumns = [
    {
        key: "username",
        label: "Email",
    },
    {
        key: "name",
        label: "Name",
    },
    {
        key: "company_id",
        label: "Company",
    },
    {
        key: "tools",
        label: "Tools",
    },
];
const CellContent = ({ user, contentKey, editUser, removeUser, companies, }) => {
    switch (contentKey) {
        case "tools":
            return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.SmallButton, { onClick: () => removeUser(user), children: "Remove" }), (0, jsx_runtime_1.jsx)(common_styled_components_1.SmallButton, { onClick: () => editUser(user), children: "Edit" })] }));
        case "company_id":
            return ((0, jsx_runtime_1.jsx)("div", { children: companies.find((c) => c.id === user.company_id)?.name ??
                    user.company_id }));
        case "name":
            return (0, jsx_runtime_1.jsx)("div", { children: user.name ?? "" });
        default:
            return (0, jsx_runtime_1.jsx)("div", { children: user[contentKey] });
    }
};
exports.default = () => {
    const [users, _setUrl, _setBody, refresh] = (0, useFetch_1.default)("admin/users.json", undefined);
    const { selectedYear } = (0, YearContext_1.useYear)();
    const [overview, _setOverviewUrl, setOverviewBody] = (0, useFetch_1.default)("admin/overview.json", undefined, true);
    (0, react_1.useEffect)(() => {
        setOverviewBody(JSON.stringify({ pool_year: selectedYear }));
    }, [selectedYear, setOverviewBody]);
    const [editStatus, executeEdit] = (0, useEdit_1.default)("admin/user.json", refresh);
    const [modal, setModal] = (0, react_1.useState)({});
    const addUser = () => {
        setModal({
            type: "add",
            value: undefined,
        });
    };
    const editUser = (user) => {
        setModal({
            type: "edit",
            value: user,
        });
    };
    const removeUser = (user) => {
        setModal({
            type: "remove",
            value: user,
        });
    };
    const submit = (type, value) => {
        setModal({});
        const name = !(0, isNullish_1.isNullish)(value.name) && value.name !== "" ? value.name : null;
        if (type === "add") {
            if ((0, compliance_pool_types_1.isValidUserInput)(value)) {
                const data = {
                    name,
                    username: value.username,
                    company_id: value.company_id,
                    id: null,
                };
                executeEdit(data, "PUT");
            }
            else {
                alert("Empty name or user id");
            }
        }
        if (type === "edit") {
            if ((0, compliance_pool_types_1.isValidUserInput)(value) && !(0, isNullish_1.isNullish)(value.id)) {
                const data = {
                    name,
                    username: value.username,
                    company_id: value.company_id,
                    id: value.id,
                };
                executeEdit(data, "PUT");
            }
            else {
                alert("Empty name");
            }
        }
        if (type === "remove") {
            if (value.id !== undefined) {
                const data = {
                    id: value.id,
                };
                executeEdit(data, "DELETE");
            }
        }
    };
    return ((0, jsx_runtime_1.jsxs)(common_styled_components_1.PageContent, { align: "left", children: [modal.type && ((0, jsx_runtime_1.jsx)(Modal_1.Modal, { type: "user", isOpen: modal.type !== undefined, closeModal: () => setModal({}), modalType: modal.type, value: modal.value, submit: submit })), (0, jsx_runtime_1.jsx)(common_styled_components_1.ContentGrid, { "$cols": 1, children: (0, jsx_runtime_1.jsxs)(common_styled_components_1.GridCard, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.TitleWithExtraContent, { titleLevel: "Section", extraContent: (0, jsx_runtime_1.jsx)(common_styled_components_1.Button, { onClick: addUser, children: "+ Add" }), children: "Users" }), (0, jsx_runtime_1.jsxs)(common_styled_components_1.Table, { children: [(0, jsx_runtime_1.jsx)("thead", { children: (0, jsx_runtime_1.jsxs)("tr", { children: [tableColumns.map((c) => ((0, jsx_runtime_1.jsx)(common_styled_components_1.TH, { children: c.label }, c.key))), " "] }) }), (0, jsx_runtime_1.jsx)("tbody", { children: users.status === apiUtils_1.LoaderStatus.Success &&
                                        overview.status === apiUtils_1.LoaderStatus.Success &&
                                        overview.data.companies &&
                                        users.data.map((user) => ((0, jsx_runtime_1.jsx)(common_styled_components_1.TR, { children: tableColumns.map((c) => ((0, jsx_runtime_1.jsx)(common_styled_components_1.TD, { children: (0, jsx_runtime_1.jsx)(CellContent, { contentKey: c.key, user: user, removeUser: removeUser, editUser: editUser, companies: overview.data.companies }) }, c.key))) }, user.id))) })] })] }) })] }));
};
